import {Component, Input, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

/**
 * This component displays a modal, which contents will be decided in a child component.
 */
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.less'],
  imports: [CommonModule]
})
export class ModalComponent {
  activeModal = inject(NgbActiveModal);


  /** A title of a modal. */
  @Input() title: string;
}
